/* tslint:disable */
/* eslint-disable */
/**
 * rpls API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface DtoRplsAggregate
 */
export interface DtoRplsAggregate {
    /**
     * 
     * @type {number}
     * @memberof DtoRplsAggregate
     */
    'lat'?: number;
    /**
     * 
     * @type {number}
     * @memberof DtoRplsAggregate
     */
    'lon'?: number;
    /**
     * 
     * @type {string}
     * @memberof DtoRplsAggregate
     */
    'adresse'?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoRplsAggregate
     */
    'nomPgm'?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoRplsAggregate
     */
    'gesPgm'?: string;
    /**
     * 
     * @type {number}
     * @memberof DtoRplsAggregate
     */
    'nbLog'?: number;
    /**
     * 
     * @type {string}
     * @memberof DtoRplsAggregate
     */
    'typeLog'?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoRplsAggregate
     */
    'typeProp'?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoRplsAggregate
     */
    'anneeCons'?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoRplsAggregate
     */
    'anneePatri'?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoRplsAggregate
     */
    'anneeLoc'?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoRplsAggregate
     */
    'plg_IRIS2022'?: string;
    /**
     * 
     * @type {string}
     * @memberof DtoRplsAggregate
     */
    'originPatri'?: string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof DtoRplsAggregate
     */
    'nbPieces'?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof DtoRplsAggregate
     */
    'financement'?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface GeoLocRplsData
 */
export interface GeoLocRplsData {
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'REG_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'REG_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'DEP_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'DEP_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'EPCI_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'EPCI_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'DROIT_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'DROIT_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'DEPCOM_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'DEPCOM_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Code_Postal'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Numero_de_voie'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Indice_de_repetition'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Type_de_voie'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Nom_de_voie'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Etage'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Nom_du_Programme'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Lieu_Dit'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'QPV_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'QPV_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'TYPECONST_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'TYPECONST_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Nombre_de_pieces'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Surface_habitable'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Annee_de_construction'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Annee_de_premiere_mise_en_location'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Annee_d_entree_dans_le_patrimoine'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Origine_de_l_entree_dans_le_patrimoine'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'FINAN_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'FINAN_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Complement_du_financement'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Convention_APL'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Numero_de_Convention'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Date_de_convention'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'NEWLOGT_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'NEWLOGT_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Categorie_financement_CUS'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Date_du_DPE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Etiquette_DPE_Energie'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Etiquette_DPE_GES'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Annee_expiration_de_la_convention'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Alinea_SRU'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Code_segment_patrimoine'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Libelle_gestion_patrimoine'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'PMR_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'PMR_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Libelle_de_la_voie_dans_le_referentiel_INSEE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Systeme_de_coordonnees_utilisee'?: string;
    /**
     * 
     * @type {number}
     * @memberof GeoLocRplsData
     */
    'Coordonnee_X'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoLocRplsData
     */
    'Coordonnee_Y'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Code_QPV'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'PLG_IRIS2022_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'PLG_IRIS2022_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Code_ZUS'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Code_ZFU'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Code_QVA'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Qualite_de_la_geolocalisation_de_la_voie'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Qualite_de_la_geolocalisation_du_numero'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Qualite_de_la_geolocalisation'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Erreur_maximum_de_positionnement'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Qualite_du_geocodage_pour_le_QPV'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Qualite_du_geocodage_pour_l_IRIS'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Qualite_du_geocodage_pour_le_ZUS'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Qualite_du_geocodage_pour_le_ZFU'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Qualite_du_geocodage_pour_le_QVA'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Indicatrice_de_presence_d_un_QPV_dans_la_commune'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Indicatrice_de_presence_d_une_ZUS'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'COMIRIS'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Unite_Urbaine_base_2020'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Aire_d_attraction_des_villes_base_2020'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'Zone_d_emploi_base_2020'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'rEG_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'rEG_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'dEP_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'dEP_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'ePCI_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'ePCI_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'dROIT_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'dROIT_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'dEPCOM_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'dEPCOM_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'code_Postal'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'numero_de_voie'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'indice_de_repetition'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'type_de_voie'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'nom_de_voie'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'etage'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'nom_du_Programme'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'lieu_Dit'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'qPV_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'qPV_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'tYPECONST_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'tYPECONST_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'nombre_de_pieces'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'surface_habitable'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'annee_de_construction'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'annee_de_premiere_mise_en_location'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'annee_d_entree_dans_le_patrimoine'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'origine_de_l_entree_dans_le_patrimoine'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'fINAN_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'fINAN_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'complement_du_financement'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'convention_APL'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'numero_de_Convention'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'date_de_convention'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'nEWLOGT_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'nEWLOGT_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'categorie_financement_CUS'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'date_du_DPE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'etiquette_DPE_Energie'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'etiquette_DPE_GES'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'annee_expiration_de_la_convention'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'alinea_SRU'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'code_segment_patrimoine'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'libelle_gestion_patrimoine'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'pMR_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'pMR_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'libelle_de_la_voie_dans_le_referentiel_INSEE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'systeme_de_coordonnees_utilisee'?: string;
    /**
     * 
     * @type {number}
     * @memberof GeoLocRplsData
     */
    'coordonnee_X'?: number;
    /**
     * 
     * @type {number}
     * @memberof GeoLocRplsData
     */
    'coordonnee_Y'?: number;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'code_QPV'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'pLG_IRIS2022_CODE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'pLG_IRIS2022_LIBELLE'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'code_ZUS'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'code_ZFU'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'code_QVA'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'qualite_de_la_geolocalisation_de_la_voie'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'qualite_de_la_geolocalisation_du_numero'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'qualite_de_la_geolocalisation'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'erreur_maximum_de_positionnement'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'qualite_du_geocodage_pour_le_QPV'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'qualite_du_geocodage_pour_l_IRIS'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'qualite_du_geocodage_pour_le_ZUS'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'qualite_du_geocodage_pour_le_ZFU'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'qualite_du_geocodage_pour_le_QVA'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'indicatrice_de_presence_d_un_QPV_dans_la_commune'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'indicatrice_de_presence_d_une_ZUS'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'cOMIRIS'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'unite_Urbaine_base_2020'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'aire_d_attraction_des_villes_base_2020'?: string;
    /**
     * 
     * @type {string}
     * @memberof GeoLocRplsData
     */
    'zone_d_emploi_base_2020'?: string;
}

/**
 * RplsCtrlApi - axios parameter creator
 * @export
 */
export const RplsCtrlApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rplsCommuneGet: async (code?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rpls/commune`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rplsGet: async (code?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rpls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rplsLoadGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rpls/load`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rplsRpls2Get: async (code?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rpls/rpls2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rplsRplsGet: async (code?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rpls/rpls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RplsCtrlApi - functional programming interface
 * @export
 */
export const RplsCtrlApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RplsCtrlApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rplsCommuneGet(code?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rplsCommuneGet(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RplsCtrlApi.rplsCommuneGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rplsGet(code?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rplsGet(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RplsCtrlApi.rplsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rplsLoadGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rplsLoadGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RplsCtrlApi.rplsLoadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rplsRpls2Get(code?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GeoLocRplsData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rplsRpls2Get(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RplsCtrlApi.rplsRpls2Get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rplsRplsGet(code?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DtoRplsAggregate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rplsRplsGet(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RplsCtrlApi.rplsRplsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RplsCtrlApi - factory interface
 * @export
 */
export const RplsCtrlApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RplsCtrlApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rplsCommuneGet(code?: string, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.rplsCommuneGet(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rplsGet(code?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.rplsGet(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rplsLoadGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rplsLoadGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rplsRpls2Get(code?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<GeoLocRplsData>> {
            return localVarFp.rplsRpls2Get(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rplsRplsGet(code?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DtoRplsAggregate>> {
            return localVarFp.rplsRplsGet(code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RplsCtrlApi - object-oriented interface
 * @export
 * @class RplsCtrlApi
 * @extends {BaseAPI}
 */
export class RplsCtrlApi extends BaseAPI {
    /**
     * 
     * @param {string} [code] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RplsCtrlApi
     */
    public rplsCommuneGet(code?: string, options?: RawAxiosRequestConfig) {
        return RplsCtrlApiFp(this.configuration).rplsCommuneGet(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [code] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RplsCtrlApi
     */
    public rplsGet(code?: string, options?: RawAxiosRequestConfig) {
        return RplsCtrlApiFp(this.configuration).rplsGet(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RplsCtrlApi
     */
    public rplsLoadGet(options?: RawAxiosRequestConfig) {
        return RplsCtrlApiFp(this.configuration).rplsLoadGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [code] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RplsCtrlApi
     */
    public rplsRpls2Get(code?: string, options?: RawAxiosRequestConfig) {
        return RplsCtrlApiFp(this.configuration).rplsRpls2Get(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [code] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RplsCtrlApi
     */
    public rplsRplsGet(code?: string, options?: RawAxiosRequestConfig) {
        return RplsCtrlApiFp(this.configuration).rplsRplsGet(code, options).then((request) => request(this.axios, this.basePath));
    }
}



